import { render } from "./LivingWillUserStatistic.vue?vue&type=template&id=fb28612a"
import script from "./LivingWillUserStatistic.vue?vue&type=script&lang=js"
export * from "./LivingWillUserStatistic.vue?vue&type=script&lang=js"
script.render = render

export default script